(function () {
  'use strict';

  // The pistols add-on flyout is the scope for the source-aware footer (mirrors the cart
  // drawer's byrna-cart-restrictions.js, but counts add-ons). Other [data-state-*] nodes
  // (cart drawer, standard PDP) are owned by their own consumers. (#1364)
  var FLYOUT_SEL = '.pdp-offcanvas-content-wrapper';

  // Last (state|outcome) shown in the flyout result row — dedupes the GA4 impression.
  var lastFlyoutViewKey = null;

  function show(el, on) {
    if (el) el.classList.toggle('is-hidden', !on);
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = (s == null) ? '' : s;
    return d.innerHTML;
  }

  // Canonicalize a state name for MATCHING only (display uses the original).
  // Mirrors byrna-cart-restrictions.js — guards the 3 known DC metafield spellings
  // and makes matching case-insensitive.
  function canon(s) {
    s = (s == null ? '' : String(s)).trim().toLowerCase();
    if (s === 'washington dc' || s === 'washington d.c.' ||
        s === 'district of columbia (d.c.)' || s === 'd.c.' || s === 'dc') {
      return 'district of columbia';
    }
    return s;
  }

  // ── Restriction warning ───────────────────────────────────────────
  function handleRestriction(state) {
    var notice = document.querySelector('[data-pdp-restriction]');
    if (!notice) return;

    if (!state) {
      notice.classList.add('is-hidden');
      return;
    }

    var restrictions = (notice.dataset.restrictions || '').split(',').map(function (s) { return canon(s); });
    var isRestricted = restrictions.indexOf(canon(state)) > -1;

    if (isRestricted) {
      notice.querySelector('.pdp-restriction-notice__msg').textContent =
        'This product cannot ship to ' + state + '.';
      notice.classList.remove('is-hidden');
      window.ByrnaGA4 && window.ByrnaGA4.featureView('shipping_restriction_warning', '1364', {
        surface: 'pdp',
        element: 'pdp_warning',
        step: state
      });
    } else {
      notice.classList.add('is-hidden');
    }
  }

  // ── City restrictions within the detected state ───────────────────
  // Entries are "City, State" (custom.city_restrictions metafield, '|'-joined).
  // Hidden until the detected state matches an entry's state — then highlighted.
  function handleCityRestriction(state) {
    var note = document.querySelector('[data-pdp-city-restrictions]');
    if (!note) return;

    if (!state) {
      note.classList.add('is-hidden');
      return;
    }

    // If the product can't ship to the whole state, the state-level warning already
    // covers it — a per-city breakdown on top of that is redundant noise.
    var stateNotice = document.querySelector('[data-pdp-restriction]');
    if (stateNotice) {
      var stateList = (stateNotice.dataset.restrictions || '').split(',').map(canon);
      if (stateList.indexOf(canon(state)) > -1) {
        note.classList.add('is-hidden');
        return;
      }
    }

    var cities = (note.getAttribute('data-pdp-city-restrictions') || '')
      .split('|')
      .map(function (entry) {
        var i = entry.lastIndexOf(',');
        if (i === -1) return null;
        return { city: entry.slice(0, i).trim(), state: canon(entry.slice(i + 1)) };
      })
      .filter(function (e) { return e && e.state === canon(state); })
      .map(function (e) { return e.city; });

    if (cities.length) {
      note.textContent = '⚠ Within ' + state + ", this product can't ship to " + cities.join(', ') + '.';
      note.classList.remove('is-hidden');
      window.ByrnaGA4 && window.ByrnaGA4.featureView('shipping_restriction_warning', '1364', {
        surface: 'pdp',
        element: 'pdp_city_warning',
        step: state
      });
    } else {
      note.classList.add('is-hidden');
    }
  }

  // ── Surface attribution ───────────────────────────────────────────
  function surfaceOf(node) {
    if (node.closest('.theme-ajax-cart')) return 'cart';
    if (node.closest(FLYOUT_SEL)) return 'flyout';
    return 'pdp';
  }

  // ── CTA impression — funnel denominator for state_confirmed ───────
  // Fires once per surface per page, only when the EMPTY dropdown becomes
  // visible (drawer opened / scrolled into view). A pre-filled or collapsed
  // CTA is not an "unselected" impression.
  var ctaSeen = {};
  var ctaObserver = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var cta = entry.target;
          var sel = cta.querySelector('[data-state-select]');
          if (!sel || sel.value) return;
          var surface = surfaceOf(cta);
          if (ctaSeen[surface]) return;
          ctaSeen[surface] = true;
          ctaObserver.unobserve(cta);
          window.ByrnaGA4 && window.ByrnaGA4.featureView('shipping_restriction_warning', '1364', {
            surface: surface, // cart | flyout | pdp
            element: 'state_cta_view'
          });
        });
      }, { threshold: 0.5 })
    : null;

  function observeCtaImpressions() {
    if (!ctaObserver) return;
    document.querySelectorAll('[data-state-cta]').forEach(function (cta) {
      if (!ctaSeen[surfaceOf(cta)]) ctaObserver.observe(cta); // re-observe survives AJAX re-renders
    });
  }

  // ── State dropdown ────────────────────────────────────────────────
  function initDropdowns(state) {
    document.querySelectorAll('[data-state-select]').forEach(function (select) {
      if (state) select.value = state;
    });
  }

  // Delegated change handler — covers state dropdowns injected later by the AJAX cart.
  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-state-select]');
    if (!select) return;
    var chosen = select.value;
    if (!chosen) return;
    localStorage.setItem('byrna_user_state', chosen);
    // Manual choice supersedes an older quiz answer — without this, the quiz key
    // (priority 1 in byrna-state-detect) wins again on the next page load.
    localStorage.removeItem('trial_state');
    window.byrnaDetectedState = { state: chosen, source: 'manual' };
    document.dispatchEvent(new CustomEvent('byrna:stateDetected', {
      bubbles: false,
      detail: { state: chosen, source: 'manual' }
    }));
    window.ByrnaGA4 && window.ByrnaGA4.featureComplete('shipping_restriction_warning', '1364', {
      surface: surfaceOf(select), // which surface converted: cart | flyout | pdp
      element: 'state_confirmed',
      step: 'manual'
    });
  });

  // ── Add-on flyout per-item ship status ───────────────────────────
  // Only items that carry a shipping restriction ([data-addon-restrictions]) get a
  // status line — same scope as the cart's per-item flip. Restricted in the detected
  // state → loud red "Can't ship to X"; otherwise a quiet "Ships" confirmation. Items
  // with no restriction (lasers, grips, targets, …) stay clean — no redundant line.
  function handleAddonRestrictions(state) {
    document.querySelectorAll('[data-addon-restrictions]').forEach(function (item) {
      var badge = item.querySelector('.pistol-pdp-addon-restrict');
      if (!badge) return;

      if (!state) {
        badge.classList.add('is-hidden');
        badge.classList.remove('is-restricted', 'is-eligible');
        badge.textContent = '';
        return;
      }

      var list = (item.getAttribute('data-addon-restrictions') || '')
        .split(',').map(function (s) { return canon(s); });

      if (list.indexOf(canon(state)) > -1) {
        badge.textContent = "⚠ Can't ship to " + state; // loud — matches the cart's per-item copy
        badge.classList.add('is-restricted');
        badge.classList.remove('is-eligible', 'is-hidden');
      } else {
        badge.textContent = '✓ Ships';                    // quiet positive confirmation
        badge.classList.add('is-eligible');
        badge.classList.remove('is-restricted', 'is-hidden');
      }
    });
  }

  // ── Add-on flyout source-aware footer (mirrors the cart drawer) ───
  // Count the add-ons in this flyout that can't ship to the detected state.
  function countAddonRestricted(root, state) {
    var count = 0;
    root.querySelectorAll('[data-addon-restrictions]').forEach(function (item) {
      var list = (item.getAttribute('data-addon-restrictions') || '')
        .split(',').map(function (s) { return canon(s); });
      if (state && list.indexOf(canon(state)) > -1) count++;
    });
    return { count: count };
  }

  // Switch the flyout CTA between dropdown / verify-note / collapsed-result views,
  // by detection source — the same model as the cart footer.
  function renderFlyoutFooter(state, source) {
    var roots = document.querySelectorAll(FLYOUT_SEL);
    if (!roots.length) return;
    var confident = (source === 'quiz' || source === 'manual');
    var shown = false, outcome = null;

    roots.forEach(function (root) {
      var cta    = root.querySelector('[data-state-cta]');
      var verify = root.querySelector('[data-state-verify]');
      var result = root.querySelector('[data-state-result]');
      var intro  = cta && cta.querySelector('.byrna-state-cta__intro');
      if (!cta || !result) return;

      if (!state) {                 // DEFAULT — dropdown only
        show(cta, true); show(verify, false); show(result, false); show(intro, true);
        return;
      }
      if (!confident) {             // VERIFY — IP/cached guess: the verify note does
        // the talking; "select your state" would contradict the pre-filled dropdown
        show(cta, true); show(verify, true); show(result, false); show(intro, false);
        return;
      }
      // CONFIRMED — quiz/manual: collapse to the result row.
      // Preserve keyboard focus if it was inside the dropdown we're hiding.
      show(intro, true); // restored for when Change re-expands the dropdown
      var hadFocus = cta.contains(document.activeElement);
      show(cta, false); show(verify, false); show(result, true);

      var info = countAddonRestricted(root, state);
      var icon = result.querySelector('[data-result-icon]');
      var text = result.querySelector('[data-result-text]');
      result.classList.remove('is-ok', 'is-warn');

      if (info.count === 0) {
        result.classList.add('is-ok');
        if (icon) icon.textContent = '✓';
        if (text) text.innerHTML = 'Everything ships to <b>' + esc(state) + '</b>.';
        outcome = 'eligible';
      } else {
        result.classList.add('is-warn');
        if (icon) icon.textContent = '⚠';
        var who = (info.count === 1) ? '1 item' : (info.count + ' items');
        if (text) text.innerHTML = '<b>' + who + "</b> can't ship to <b>" + esc(state) + '</b>.';
        outcome = 'restricted';
      }

      if (hadFocus) {
        var cb = result.querySelector('[data-state-change]');
        if (cb) cb.focus();
      }
      shown = true;
    });

    // GA4 impression — once per distinct (state, outcome); reset when not confirmed.
    if (shown && outcome) {
      var key = state + '|' + outcome;
      if (key !== lastFlyoutViewKey) {
        lastFlyoutViewKey = key;
        window.ByrnaGA4 && window.ByrnaGA4.featureView('shipping_restriction_warning', '1364', {
          surface: 'flyout', element: 'addon_state_result', step: state, label: outcome
        });
      }
    } else {
      lastFlyoutViewKey = null;
    }
  }

  // ── Standard-PDP CTA result view (#1364) ─────────────────────────
  // The cart drawer and flyout collapse their CTA into a result row on a confident
  // state. Standard PDPs previously gave no feedback at all when the product ships
  // fine — the CTA invited a "check" that answered nothing. Same three-view model,
  // scoped to CTAs owned by neither of the other two consumers.
  var lastPdpViewKey = null;

  function isPdpCta(node) {
    return node && !node.closest(FLYOUT_SEL) && !node.closest('.theme-ajax-cart');
  }

  function renderPdpCta(state, source) {
    var ctas = Array.prototype.filter.call(
      document.querySelectorAll('[data-state-cta]'), isPdpCta
    );
    if (!ctas.length) { lastPdpViewKey = null; return; }

    var confident = (source === 'quiz' || source === 'manual');
    var notice = document.querySelector('[data-pdp-restriction]');
    var shown = false, outcome = null;

    ctas.forEach(function (cta) {
      var verify = cta.querySelector('[data-state-verify]');
      var result = cta.parentElement && cta.parentElement.querySelector('[data-state-result]');
      var intro  = cta.querySelector('.byrna-state-cta__intro');
      if (!result) return;

      if (!state) {                 // DEFAULT — dropdown only
        show(cta, true); show(verify, false); show(result, false); show(intro, true);
        return;
      }
      if (!confident) {             // VERIFY — IP/cached guess: the verify note does
        // the talking; "select your state" would contradict the pre-filled dropdown
        show(cta, true); show(verify, true); show(result, false); show(intro, false);
        return;
      }
      // CONFIRMED — quiz/manual: collapse to the result row.
      show(intro, true); // restored for when Change re-expands the dropdown
      var hadFocus = cta.contains(document.activeElement);
      show(cta, false); show(verify, false); show(result, true);

      var restricted = false;
      if (notice) {
        var list = (notice.dataset.restrictions || '').split(',').map(canon);
        restricted = list.indexOf(canon(state)) > -1;
      }

      var icon = result.querySelector('[data-result-icon]');
      var text = result.querySelector('[data-result-text]');
      result.classList.remove('is-ok', 'is-warn');

      if (restricted) {
        result.classList.add('is-warn');
        if (icon) icon.textContent = '⚠';
        if (text) text.innerHTML = "Can't ship to <b>" + esc(state) + '</b>.';
        show(notice, false); // result row owns the message — no double warning
        outcome = 'restricted';
      } else {
        result.classList.add('is-ok');
        if (icon) icon.textContent = '✓';
        if (text) text.innerHTML = 'Ships to <b>' + esc(state) + '</b>.';
        outcome = 'eligible';
      }

      if (hadFocus) {
        var cb = result.querySelector('[data-state-change]');
        if (cb) cb.focus();
      }
      shown = true;
    });

    // GA4 impression — once per distinct (state, outcome); reset when not confirmed.
    if (shown && outcome) {
      var pkey = state + '|' + outcome;
      if (pkey !== lastPdpViewKey) {
        lastPdpViewKey = pkey;
        window.ByrnaGA4 && window.ByrnaGA4.featureView('shipping_restriction_warning', '1364', {
          surface: 'pdp', element: 'pdp_state_result', step: state, label: outcome
        });
      }
    } else if (!shown) {
      lastPdpViewKey = null;
    }
  }

  // ── Click delegation — flyout-scoped Change / Details + PDP learn-more ──
  document.addEventListener('click', function (e) {
    // Re-expand the flyout dropdown (does not clear stored state). Cart Change clicks
    // are ignored here — they're owned by byrna-cart-restrictions.js.
    var changeBtn = e.target.closest('[data-state-change]');
    if (changeBtn) {
      var froot = changeBtn.closest(FLYOUT_SEL);
      if (froot) {
        show(froot.querySelector('[data-state-cta]'), true);
        show(froot.querySelector('[data-state-result]'), false);
        var sel = froot.querySelector('[data-state-select]');
        if (sel) sel.focus();
        window.ByrnaGA4 && window.ByrnaGA4.featureClick('shipping_restriction_warning', '1364', {
          surface: 'flyout', element: 'addon_state_change'
        });
        return;
      }
      if (changeBtn.closest('.theme-ajax-cart')) return; // cart owns its Change
      // Standard PDP — re-expand the dropdown next to this result row
      var presult = changeBtn.closest('[data-state-result]');
      var pcta = presult && presult.parentElement &&
        presult.parentElement.querySelector('[data-state-cta]');
      if (!pcta) return;
      show(pcta, true);
      show(presult, false);
      var psel = pcta.querySelector('[data-state-select]');
      if (psel) psel.focus();
      window.ByrnaGA4 && window.ByrnaGA4.featureClick('shipping_restriction_warning', '1364', {
        surface: 'pdp', element: 'pdp_state_change'
      });
      return;
    }
    if (e.target.closest('.pdp-restriction-notice__link')) {
      window.ByrnaGA4 && window.ByrnaGA4.featureClick('shipping_restriction_warning', '1364', {
        surface: 'pdp', element: 'pdp_restriction_link'
      });
    }
  });

  // ── Bootstrap ─────────────────────────────────────────────────────
  function bootstrap(state, source) {
    handleRestriction(state);
    handleCityRestriction(state);
    handleAddonRestrictions(state);
    initDropdowns(state);
    renderFlyoutFooter(state, source);
    renderPdpCta(state, source); // after handleRestriction — may hide its notice
    observeCtaImpressions();     // re-runs on every state event — picks up re-rendered CTAs
  }

  // Check if detection already resolved (fast path — quiz/manual/cached)
  if (window.byrnaDetectedState) {
    bootstrap(window.byrnaDetectedState.state, window.byrnaDetectedState.source);
  } else {
    // Waiting for ipinfo or first-visit detection
    bootstrap(null, null);
  }

  // Always listen for updates (state change via dropdown or late ipinfo resolve)
  document.addEventListener('byrna:stateDetected', function (e) {
    bootstrap(e.detail.state, e.detail.source);
  });

})();
